import React, { useEffect } from "react";
import translate from "../../../i18n/translate";
import "../PageNotFoundPage/PageNotFound.scss";

const MaintenancePage = (props: any) => {
    useEffect(() => {
        if (props.maintenanceMins != "" && parseInt(props.maintenanceMins) > 0) {
            const checkTimer: any = setInterval(() => {
                window.location.reload();
            }, 60000);
        }
    }, [])
    return (
        <div className="MaintenancePage-Container">
            <div className="ErrorMessage">
                <div>
                    <img                   
                        src={window.location.origin + "/images/errorPage/error-img.png"}
                        alt="ErrorPage Illustration"
                        title="ErrorPage Illustration"
                    />
                </div>
                <div>
                    {/* <h1>{translate("error_under")}</h1> */}
                    <h4>{translate("error_under")} {translate("error_maintenance")}</h4> 
                    <p>{translate("error_under_maintenance")}</p>
                    <p>{translate("error_inconvenience")}</p>
                    <p>{translate("error_tryagain")}</p>
                    {!isNaN(props.maintenanceMins) && props.maintenanceMins>0 && <p> {translate("error_tryagainMins")} {parseInt(props.maintenanceMins)/60 >= 1 && Math.floor(parseInt(props.maintenanceMins)/60)} { parseInt(props.maintenanceMins)/60 >= 1 && translate("error_hours")} {parseInt(props.maintenanceMins)%60} {translate("error_minutes")} </p>}
                    {props.maintenanceMins==="" && <p>{translate("error_tryagain")}</p>}
                </div>
            </div>
        </div>
    );
};

export default MaintenancePage;
